import { useEffect, useRef, useState } from "react";

// How long a list search waits for the typing to settle before it is sent.
export const SEARCH_DELAY_MS = 500;

// A list screen's search box, debounced into its list query.
//
// The list queries are kept in the persisted store (store/configureStore.js),
// so the box starts with the search the stored query already filters by:
// coming back to a list shows the search its rows are filtered by, and
// nothing is sent when the list opens (no request with a search the box does
// not show, no reset to page 1, F-BUG-11). A typed change is sent through
// onSearch once it has settled; onSearch is read when the timer fires, so it
// builds the query from the latest store query, not the one of the render
// that started the timer.
//
// Returns [value, setValue] for the search input.
const useListSearch = (storedValue, onSearch, delay = SEARCH_DELAY_MS) => {
  const stored = storedValue || "";
  const [value, setValue] = useState(stored);
  const onSearchRef = useRef(onSearch);
  onSearchRef.current = onSearch;

  useEffect(() => {
    if (value === stored) {
      return undefined;
    }
    const timer = setTimeout(() => onSearchRef.current(value), delay);
    return () => clearTimeout(timer);
  }, [value, stored, delay]);

  return [value, setValue];
};

export default useListSearch;
